const SessionStudentResultStatusEnum = {
  BEFORE_EXAM_DATE: "BEFORE_EXAM_DATE",
  NOT_EVALUATED: "NOT_EVALUATED",
  SCHOOL_SETTING_NOT_EXIST: "SCHOOL_SETTING_NOT_EXIST",
  SCHOOL_SETTING_EXIST: "SCHOOL_SETTING_EXIST"
};

export { SessionStudentResultStatusEnum };
